export const DOWNLOAD_APP_LINK =
  'https://tw-download-app.onelink.me/yUU8/cyweb37m';
export const LOYALTY_PAGE_TYPE = 'treatwellRewards';
